<template>
  <section class="notification-backdrop" v-show="isModalVisible" @click="handleClose">
    <div class="notification is-warning is-light">
      <button class="delete" @click="handleClose"></button>
      <p>
        Welcome! Before you continue, let's remember to stay safe online. Be mindful of the real-world risks when sharing
        information or media. Let's make our online experience positive and secure.
      </p>
      <div class="">
        <button class="btn btn-theme is-fullwidth" @click="handleClose">Ok</button>
      </div>
    </div>
  </section>
</template>

<script>
import { auth, db } from '../main';

export default {
  name: 'popup',
  data() {
    return {
      isModalVisible: false
    }
  },
  methods: {
    showModal() {
      this.isModalVisible = true
    },
    handleClose() {
      this.isModalVisible = false;
      this.updateTimestamp();
    },
    updateTimestamp() {
      if (!auth.currentUser.uid) return;

      db.collection("users").doc(auth.currentUser.uid).update({
        pc_timestamp: new Date().getTime()
      })
    },
    getHoursDiff(date1, date2) {
      if (!date1 || !date2) return;

      const hours = Math.round(Math.abs(date1 - date2) / 3600000);
      return hours;
    }
  },
  mounted() {
    auth.onAuthStateChanged(async (user) => {
      if (!user) return;

      const userInfo = await db.collection("users").doc(user.uid).get();
      const lastViewedTimestamp = userInfo.data().pc_timestamp;

      if (!lastViewedTimestamp) {
        this.showModal();
        return;
      }

      const hoursDiff = this.getHoursDiff(new Date().getTime(), lastViewedTimestamp);

      if (hoursDiff >= 24) {
        this.showModal();
      }
    })
  }
}
</script>

<style scoped>
.notification-backdrop {
  position: fixed;
  background: rgba(0, 0, 0, 0.3);
  z-index: 111111;
  bottom: 0;
  height: 100%;
  width: 100%;
  padding: 4rem;
  display: flex;
  justify-content: center;
  align-items: center;
}

.notification-backdrop .delete {
  background-color: black;
}

.notification-backdrop .notification {
  width: 80%;
  position: absolute;
  bottom: 5%;
  left: 0;
  left: 50%;
  transform: translate(-50%, -5%);
  background-color: #fffaeb;
  color: #946c00;
  border-radius: 15px;
}
</style>